// Hosted legal pages. Apple requires FUNCTIONAL Terms of Use (EULA) + Privacy Policy
// links on the subscription paywall (Guideline 3.1.2). The pages ship in `infra/site/`
// (terms.html / privacy.html) and deploy to the static site (CloudFront at SITE_DOMAIN).
// The OAC S3 origin has no directory index, so the working URLs end in `.html`.
// Override EXPO_PUBLIC_TERMS_URL / EXPO_PUBLIC_PRIVACY_URL to your production domain.
//
// The host is `app.saddle-sites.com`, NOT the apex. The pages deploy to the distribution
// that serves published sites, and the apex is a different distribution that has never
// had them — so both links answered 404, on the one screen Apple requires them to work.
export const LEGAL_HOST = process.env.EXPO_PUBLIC_LEGAL_HOST ?? 'https://app.saddle-sites.com';
export const TERMS_URL = process.env.EXPO_PUBLIC_TERMS_URL ?? `${LEGAL_HOST}/terms.html`;
export const PRIVACY_URL = process.env.EXPO_PUBLIC_PRIVACY_URL ?? `${LEGAL_HOST}/privacy.html`;

/**
 * Where a person writes when something has gone wrong.
 *
 * App Review 1.2 asks for "published contact information so users can easily reach you",
 * and this is the address the published terms already give — so the app and the terms say
 * the same thing rather than two different ones.
 */
export const SUPPORT_EMAIL = process.env.EXPO_PUBLIC_SUPPORT_EMAIL ?? 'support@saddle-sites.com';
